import styled from 'styled-components';

import colors from '../../styles/colors';
import { ReactComponent as MicIcon } from '../../assets/icons/mic-icon.svg';

/*
  Hidden rather than unmounted: Smart Context holds its answer, its query and an in-flight
  generation in local state, and `display: none` also drops it out of the grid entirely, so the
  thread inbox takes the drawer column while it is hidden.
*/
const DrawerSlot = styled.div`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'contents')};
`;

// The second column is the side drawer slot, shared by Smart Context and the thread inbox.
const SingleChannelWrapper = styled.div`
  display: ${({ $sideDrawerVisible }) => ($sideDrawerVisible ? 'grid' : 'block')};
  grid-template-columns: 1fr 400px;
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: ${({ $width }) => ($width || '100')}%;
`;

const NotificationBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 10px 16px;
  background-color: ${colors.shades.gamma8};
  font-size: 0.8rem;
  font-weight: 500;
`;

const LinkSpan = styled.span`
  color: ${colors.shades.secondary1};
  cursor: pointer;
  text-decoration: underline;
  margin-left: 8px;
  &:hover {
    color: ${colors.shades.secondary2};
  }
  &:active {
    color: ${colors.shades.alpha1};
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ClientInactiveNotification = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: ${colors.shades.gamma8};
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
`;

const VoiceNotePilotBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  background-color: ${({ $isVariant }) => ($isVariant ? colors.shades.primary3 : colors.shades.gamma8)};
  color: ${({ $isVariant }) => ($isVariant ? colors.shades.secondary8 : colors.base.secondary2)};
  border-bottom: 1px solid ${({ $isVariant }) => ($isVariant ? colors.shades.primary6 : colors.shades.gamma9)};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
`;

const VoiceNotePilotMicIcon = styled(MicIcon)`
  height: 16px;
  width: auto;
  flex-shrink: 0;
`;

export {
  Container,
  DrawerSlot,
  NotificationBox,
  LinkSpan,
  TextContainer,
  ClientInactiveNotification,
  VoiceNotePilotBanner,
  VoiceNotePilotMicIcon,
  SingleChannelWrapper,
};
